import { createEventHook } from '@vueuse/core';

import {
  WebSocketClient,
  type Chat,
  type Message,
  type MessageReadPayload,
  type MessageDeletePayload,
  type MessageReactionUpdatedPayload,
  type UnreadMessageCount,
} from '@/shared/api';

const MessageEventsController = () => {
  const { on: onNewMessage, trigger: newMessageTrigger } = createEventHook<{
    chatId: Chat['id'];
    payload: Message;
  }>();
  WebSocketClient.on('NewMessageEvent', (data) => {
    if (data.chatId) {
      newMessageTrigger({ chatId: data.chatId, payload: data });
    }
  });

  const { on: onUpdateMessage, trigger: updateMessageTrigger } = createEventHook<{
    chatId: Chat['id'];
    payload: Message;
  }>();
  WebSocketClient.on('UpdateMessageEvent', (data) => {
    if (data.chatId) {
      updateMessageTrigger({ chatId: data.chatId, payload: data });
    }
  });

  const { on: onReadMessage, trigger: readMessageTrigger } = createEventHook<{
    chatId: Chat['id'];
    payload: MessageReadPayload;
  }>();
  WebSocketClient.on('MessageReadEvent', (data) => {
    if (data.chatId) {
      readMessageTrigger({ chatId: data.chatId, payload: data });
    }
  });

  const { on: onDeleteMessage, trigger: deleteMessageTrigger } = createEventHook<{
    chatId: Chat['id'];
    payload: MessageDeletePayload;
  }>();
  WebSocketClient.on('DeleteMessageEvent', (data) => {
    if (data.chatId) {
      deleteMessageTrigger({ chatId: data.chatId, payload: data });
    }
  });

  const { on: onReactionUpdated, trigger: reactionUpdatedTrigger } = createEventHook<{
    chatId: Chat['id'];
    payload: MessageReactionUpdatedPayload;
  }>();
  WebSocketClient.on('MessageReactionUpdatedEvent', (data) => {
    if (data.chatId && data.messageId) {
      reactionUpdatedTrigger({ chatId: data.chatId, payload: data });
    }
  });

  const { on: onUnreadMessageCountUpdated, trigger: unreadMessageCountUpdatedTrigger } =
    createEventHook<UnreadMessageCount>();
  WebSocketClient.on('UnreadMessageCountUpdatedEvent', (data) => {
    unreadMessageCountUpdatedTrigger(data);
  });

  return {
    onNewMessage,
    onUpdateMessage,
    onReadMessage,
    onDeleteMessage,
    onReactionUpdated,
    onUnreadMessageCountUpdated,
  };
};

const MessageEvents = MessageEventsController();

export { MessageEvents };
